// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "img.disabled {\n  opacity: 0.1;\n}", "",{"version":3,"sources":["webpack://./src/app/shared/product-description-image/product-description-image.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;AACJ","sourcesContent":["img.disabled {\n    opacity: 0.1;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
